import React from 'react';
import {
    COVER_DIM_ON_LIGHT,
    COVER_DISPLAY_FONT_VAR,
    CoverLogo,
    coverTitleSize,
    withAlpha,
    type CoverTemplateProps,
} from './shared';

/** Grid suíço: moldura fina, círculo de traço fino e meta em três colunas. */
export const Estrutura: React.FC<CoverTemplateProps> = ({ fields, colors, logoUrl, showLogo }) => {
    const hairline = withAlpha(colors.primary, 0.3);

    const cells = [
        fields.patient_name
            ? { key: 'patient', strong: fields.patient_name, dim: 'Paciente' }
            : null,
        fields.solicitante
            ? { key: 'solicitante', strong: fields.solicitante, dim: undefined }
            : null,
        fields.psychologist_name || fields.crp || fields.city_date
            ? {
                  key: 'psychologist',
                  strong: fields.psychologist_name,
                  dim: [fields.crp, fields.city_date].filter(Boolean).join(' · '),
              }
            : null,
    ].filter(Boolean) as Array<{ key: string; strong?: string; dim?: string }>;

    return (
        <div className="size-full p-[1.6em]">
            <div
                className="relative flex h-full flex-col overflow-hidden border px-[2em] pb-[1.6em] pt-[2em]"
                style={{ borderColor: hairline }}
            >
                <div
                    className="absolute right-[-3.6em] top-[8.2em] size-[13em] rounded-full border"
                    style={{ borderColor: withAlpha(colors.primary, 0.35) }}
                />
                <CoverLogo logoUrl={logoUrl} showLogo={showLogo} className="h-[2.4em]" />
                <div className="relative mt-[6.6em]">
                    {fields.subtitle ? (
                        <div
                            className="mb-[1.4em] font-semibold uppercase tracking-[0.3em]"
                            style={{
                                fontSize: coverTitleSize(0.62),
                                color: colors.primary,
                            }}
                        >
                            {fields.subtitle}
                        </div>
                    ) : null}
                    <div
                        className="font-bold leading-[1.05] tracking-[-0.025em]"
                        style={{
                            fontFamily: COVER_DISPLAY_FONT_VAR,
                            fontSize: coverTitleSize(2.3),
                            maxWidth: '8.5em',
                        }}
                    >
                        {fields.document_title}
                    </div>
                </div>
                {cells.length > 0 ? (
                    <div
                        className="mt-auto grid grid-cols-3 gap-[1em] border-t pt-[1em] text-[0.56em] leading-[1.7]"
                        style={{ borderColor: hairline, color: COVER_DIM_ON_LIGHT }}
                    >
                        {cells.map((cell, index) => (
                            <div
                                key={cell.key}
                                className={index === cells.length - 1 ? 'text-right' : undefined}
                            >
                                {cell.strong ? (
                                    <div className="text-[1.15em] font-semibold text-[#16181d]">
                                        {cell.strong}
                                    </div>
                                ) : null}
                                {cell.dim ? <div>{cell.dim}</div> : null}
                            </div>
                        ))}
                    </div>
                ) : null}
            </div>
        </div>
    );
};
